import { configureStore } from '@reduxjs/toolkit';
import visitsReducer from 'components/visits/visitsSlice'
import attendanceReducer from 'components/rawReport/rawSlice';
import fuelUsage from 'components/fuelUsage/fuelUsageSlice';
import csBinReducer from 'components/rawReport/CsBinCleared/csBinSlice';
import adminReducer from 'components/admin/adminSlice';
import trackSupervisorReducer from 'components/rawReport/TrackSuperVisor/trackSupervisorSlice';
import commonReducer from './base/commonSlice'
import  sessionReducer from './auth/sessionSlice';
import  userReducer from './auth/userSlice';
import  themeReducer from './theme/themeSlice';

export const store = configureStore({
  reducer: {
    attendance:attendanceReducer,
    csbin:csBinReducer,
    attendance:attendanceReducer,
    common:commonReducer,
    session:sessionReducer,
    user:userReducer,
    theme:themeReducer,
    trackSuperVisor:trackSupervisorReducer,
    fuelUsage:fuelUsage,
    admin:adminReducer,
    visits:visitsReducer
  }
});
